import {HttpErrorResponse, HttpInterceptorFn, HttpResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {tap, throwError} from 'rxjs';
import {inject} from '@angular/core';
import {ErrorLogDbService} from '../db/error-log.db.service';
import {NetworkService} from '../services/network.service';

const sanitize = (body: unknown): unknown => {
  if (!body || typeof body !== 'object') return body;

  const sensitiveKeys = ['password', 'token', 'access_token', 'refresh_token', 'contrasena'];

  const clone:  Record<string, unknown> | unknown[] = Array.isArray(body) ? [...body] : { ...(body as Record<string, unknown>) };

  if (!Array.isArray(clone)) {
    for (const key in clone) {
      if (sensitiveKeys.includes(key)) {
        clone[key] = '***';
      } else if (typeof clone[key] === 'object') {
        clone[key] = sanitize(clone[key]);
      }
    }
  }

  return clone;
};

const isErrorResponse = (
  data: unknown
): data is { status?: number; exception?: string } => {
  return typeof data === 'object' && data !== null;
};


export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorService = inject(ErrorLogDbService);
  const network = inject(NetworkService);
  return next(req).pipe(

    // CAPTURA RESPUESTAS (incluye status 200–299)
    tap((event) => {

      if (event instanceof HttpResponse) {

        const body = event.body as unknown;

        // detectar errores de negocio
        if (isErrorResponse(body) && (body.status === 250 || body.exception))  {

          errorService.log({
            message: body.exception ?? 'Error de negocio',
            status: body.status ?? 250,
            url: req.url,
            method: req.method,

            // RESPONSE
            body,

            // REQUEST
            requestBody: sanitize(req.body),

          });

        }
      }
    }),

    // ERRORES HTTP REALES
    catchError((error: unknown) => {

      let errorData: unknown = error;


      if (error instanceof HttpErrorResponse) {

        if (error.status === 0) {
          if (navigator.onLine) {
            network.setServerDown();
          } else {
            network.setOffline();
          }
        }


        errorData = {
          message: error.message,
          status: error.status,
          url: error.url,
          method: req.method,

          //RESPONSE ERROR
          body: sanitize(error.error),

          //REQUEST
          requestBody: sanitize(req.body),

          stack: error.error ?? error.message
        };
      }

      errorService.log(errorData);

      return throwError(() => error);
    })

  );

};
